"use strict";

/**
    Function to display the popover when the user icon is hovered
    */

let init = () => {
    let $userAccountIcon = $(".user");
    let $accountPopover = $(".account-popover");
    let $accountPopoverLink = $(".js-account-popover");
    let $minicartPopover = $(".minicart-popover");

    $userAccountIcon.on("mouseenter focusin touchstart", function () {
        if ($minicartPopover.length && $minicartPopover.hasClass("show")) {
            $minicartPopover.find(".js-minicart-close").trigger("click");
        }

        if ($accountPopover.find(".show").length === 0) {
            $accountPopover.addClass("show");
            $accountPopoverLink.addClass("active");
        }
    });

    $("body").on("touchstart click", function (e) {
        if ($userAccountIcon.has(e.target).length <= 0) {
            $accountPopover.removeClass("show");
            $accountPopoverLink.removeClass("active");
        }
    });

    $userAccountIcon.on("mouseleave focusout", function (event) {
        if ((event.type === "focusout" && $(".minicart").has(event.target).length > 0)
            || (event.type === "mouseleave" && $(event.target).is(".user"))) {
            event.stopPropagation();
            return;
        }
        $accountPopover.removeClass("show");
        $accountPopoverLink.removeClass("active");
    });
};

module.exports = {
    init: init
};
